
import PropTypes from "prop-types";
import { TextField, Dialog, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { makeStyles } from '@mui/styles'
const useStyles = makeStyles(
  (theme) => (
{
  dialogContent: {
    paddingTop: theme.spacing(2),
  },
  dialogActions: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}
))

function ChangePassword({toggleModal,modal}) {

  const classes = useStyles();
  const handleClose = () => {
     toggleModal();
  };

  return (
    <Dialog
      open={modal}
      hideBackdrop
      onClose={handleClose}
      maxWidth="xs">

        <DialogContent className={classes.dialogContent}>
          <Typography paragraph>
          Ingrese su dirección de correo electrónico a continuación y le enviaremos instrucciones sobre
            cómo restablecer su contraseña.
          </Typography>
          <TextField
            variant="outlined"
            margin="dense"
            required
            fullWidth
            label="Direccion de Email "
            autoFocus
            type="email"
            autoComplete="off"
          />
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={toggleModal} >
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="secondary"
          >
            Resetear contraseña
          </Button>
        </DialogActions>

    </Dialog>
  );
}

ChangePassword.propTypes = {
  modal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func,
};

export default ChangePassword;
